import { render, staticRenderFns } from "./GenericCardsCell.vue?vue&type=template&id=0fdca09c&"
import script from "./GenericCardsCell.vue?vue&type=script&lang=js&"
export * from "./GenericCardsCell.vue?vue&type=script&lang=js&"
import style0 from "./GenericCardsCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports